import { ActionPlanAction } from "src/api/client-api/ActionPlan/ActionPlanAction";
import { getImpactData } from "../../context/utils/impactData/getImpactData";

export const getImpactIndicatorCount = (actionPlanAction: ActionPlanAction, scoreId: number): number => {
    const summary = getImpactData({ actionPlanAction, scoreId }).summary.summary;
    return summary.filter(
        (item: { score: number | null | undefined }) => item.score !== null && item.score !== undefined,
    ).length;
};

export const getImpactIndicatorBreakdown = (
    actionPlanAction: ActionPlanAction,
    scoreId: number,
): { label: string; score: number }[] => {
    const summary = getImpactData({ actionPlanAction, scoreId }).summary.summary;
    return summary.flatMap((item: { label: string; score: number | null | undefined }) => {
        if (item.score === null || item.score === undefined) {
            return [];
        }
        return [{ label: item.label, score: item.score }];
    });
};
